var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H22V15.4999H0V0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 0.5H9.62498V6.59361H0V9.40605H9.62498V15.4997H12.375V9.40605H22V6.59361H12.375V0.5Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9203 10.6084L21.9998 13.4945V10.6084H16.9203ZM13.3911 10.6084L21.9998 15.4996V14.1165L15.8255 10.6084H13.3911ZM19.7067 15.4996L13.3911 11.9109V15.4996H19.7067Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3911 10.6084L21.9998 15.4996V14.1165L15.8255 10.6084H13.3911Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3911 10.6084L21.9998 15.4996V14.1165L15.8255 10.6084H13.3911Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88183 10.6084L0 12.814V10.6084H3.88183ZM8.60869 11.2304V15.4996H1.09531L8.60869 11.2304Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1743 10.6084L0 14.1165V15.4996L8.60869 10.6084H6.1743Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07954 5.3912L0 2.5051V5.3912H5.07954ZM8.60869 5.3912L0 0.5V1.88311L6.1743 5.3912H8.60869ZM2.29307 0.5L8.60869 4.08868V0.5H2.29307Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60869 5.3912L0 0.5V1.88311L6.1743 5.3912H8.60869Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60869 5.3912L0 0.5V1.88311L6.1743 5.3912H8.60869Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.118 5.39124L21.9998 3.18567V5.39124H18.118ZM13.3911 4.76925V0.5H20.9045L13.3911 4.76925Z",
    fill: "#0052B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8255 5.3912L21.9998 1.88311V0.5L13.3911 5.3912H15.8255Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.8fc2b086a3692d3d366ef270445cbabf.svg";
export { ForwardRef as ReactComponent };